import {
    getFirestore,
    collection,
    getDocs,
    doc,
    Timestamp,
    deleteDoc,
    addDoc,
} from "firebase/firestore";
import { ErrorHelper } from "../helpers/ErrorHelper";
import { FireHelper } from "../helpers/FireHelper";
import { Firebase } from "../FirebaseApp";
import { toast } from "react-toastify";
import axios from "axios";

export const DeviceController = {
    db: getFirestore(Firebase),

    ToFirestoreBoatType: function (data) {
        let updatedData = {
            id: data.id,
            name: data.name,
            value: data.value,
            created_time: data.created_time ?? Timestamp.now(),
            updated_time: Timestamp.now(),
        };
        return FireHelper.ToFirestoreDoc(updatedData);
    },

    Insert: async function (data, res) {
        try {
            const inviteRef = collection(this.db, "devices");
            const result = await addDoc(inviteRef, this.ToFirestoreBoatType(data));

            res(result.id);
        } catch (e) {
            toast(ErrorHelper.HandleMessage(e));
        }
    },

    ListByOwner: async function (ownerUserRef, res) {
        try {
            const querySnapshot = await getDocs(collection(this.db, "devices"));
            const results = querySnapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            // owner_user_ref is a DocumentReference, compare its id with userId
            const newResults = results.filter(
                (vehicle) =>
                    vehicle.owner_user_ref &&
                    vehicle.owner_user_ref.id === ownerUserRef // ownerUserRef should be userId string
            );
            res(newResults);
        } catch (e) {
            toast(ErrorHelper.HandleMessage(e));
        }
    },

    ListByVehicle: async function (vehicleRef, res) {
        try {
            const querySnapshot = await getDocs(collection(this.db, "devices"));
            const results = querySnapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            // owner_vehicle_ref is a DocumentReference, compare its id with userId
            const newResults = results.filter(
                (vehicle) =>
                    vehicle.owner_vehicle_ref &&
                    vehicle.owner_vehicle_ref.id === vehicleRef // ownerUserRef should be userId string
            );
            res(newResults);
        } catch (e) {
            toast(ErrorHelper.HandleMessage(e));
        }
    },

    ListDateLocations: async function (deviceId, start, end, res) {
        try {

            const response = await axios.post(
                "https://us-central1-rastromais-7kbpxd.cloudfunctions.net/getTrackerNetDeviceHistory",
                {
                    "data": {
                        "deviceId": deviceId,
                        "start": start,
                        "filterNullOrZero": true
                    }
                }
            );

            res(response);
        } catch (e) {
            toast(ErrorHelper.HandleMessage(e));
        }
    },

    Delete: async function (id) {
        await deleteDoc(doc(this.db, "devices", id));
        return true;
    },
};
